import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getData, postData, putData } from "../Services/api";
import { toast } from "react-toastify";

const UpdateShippingSetting = () => {
    const [values, setValues] = useState({
        isEnabled: true,
        baseCharge: "",
        codCharge: "",
        freeShippingAbove: "",
    });

    const [loading, setLoading] = useState(false);

    // 🔹 Handle input change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setValues({
            ...values,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    // 🔹 Fetch existing setting
    const fetchSettings = async () => {
        try {
            const res = await getData("/shipping");
            if (res.status) {
                setValues({
                    isEnabled: res.data.isEnabled,
                    baseCharge: res.data.baseCharge,
                    codCharge: res.data.codCharge,
                    freeShippingAbove: res.data.freeShippingAbove,
                });
            }
        } catch (error) {
            console.log("Fetch shipping error", error);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    // 🔹 Submit update
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await putData("/shipping/update", {
                isEnabled: values.isEnabled,
                baseCharge: Number(values.baseCharge),
                codCharge: Number(values.codCharge),
                freeShippingAbove: Number(values.freeShippingAbove),
            });
            if (res.status) {

                toast.success("Shipping settings updated successfully");
            }
        } catch (error) {
            toast.error(
                error?.response?.data?.message || "Failed to update shipping"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">Shipping Settings</li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <h2 className="mb-0">Shipping Settings</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h5>Update Shipping Configuration</h5>
                    </div>

                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">

                                {/* Enable Shipping */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">Enable Shipping</label>
                                        <div>
                                            <input
                                                type="checkbox"
                                                name="isEnabled"
                                                checked={values.isEnabled}
                                                onChange={handleChange}
                                            />{" "}
                                            Active
                                        </div>
                                    </div>
                                </div>

                                {/* Base Charge */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">Base Shipping Charge (₹)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="baseCharge"
                                            value={values.baseCharge}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* COD Charge */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">COD Charge (₹)</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="codCharge"
                                            value={values.codCharge}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                {/* Free Shipping Above */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Free Shipping Above (₹)
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="freeShippingAbove"
                                            value={values.freeShippingAbove}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="text-end mt-4">
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? "Saving..." : "Save Settings"}
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateShippingSetting;
